module.exports = __webpack_public_path__ + "assets/img/zyzq.fca8d702.png";